<template>
  <div
    :class="[
      bem.b(),
      bem.is(props.vertical ? 'vertical' : 'horizontal'),
      bem.is(computedColumn > 1 ? 'multi-column' : 'single-column'),
      gradient ? bem.is('gradient') : '',
    ]"
    :style="currentStyle"
  >
    <template v-for="col in computedColumn" :key="col">
      <Vue3Marquee
        v-bind="currentAttrs"
        :direction="getDirection(col)"
        :vertical="props.vertical"
        :gradient="false"
        :style="{
          transform: `rotate(${props.rotate}deg)`,
        }"
        @emit-event="$emit"
      >
        <slot :col="col" />
      </Vue3Marquee>
    </template>
  </div>
</template>

<script setup lang="ts">
import { computed, useAttrs, type StyleValue } from 'vue'
import { createNamespace } from '@ll-plus/utils'
import { marqueeProps, marqueeEmits } from './marquee'
import { omit } from 'lodash-es'

import { Vue3Marquee } from 'vue3-marquee'

defineOptions({ name: 'LlMarqueePro' })

const bem = createNamespace('marquee')

const props = defineProps(marqueeProps)
defineEmits(marqueeEmits)
const attrs = useAttrs()

const computedColumn = computed(() => {
  return props.column < 1 ? 1 : props.column
})

const currentStyle = computed(() => {
  const varName = '--ll-marquee-'
  return {
    ...(attrs.style ? attrs.style : {}),
    [`${varName}spacing`]: `${props.spacing}px`,
    [`${varName}gradient-color`]: props.gradientColor,
    [`${varName}gradient-width`]: `${props.gradientWidth}px`,
    [`${varName}left`]: props.left,
    [`${varName}top`]: props.top,
  } as StyleValue
})

const currentAttrs = computed(() => {
  return omit(attrs, 'style')
})

const getDirection = (col: number) => {
  if (typeof props.direction === 'function') {
    return props.direction(col)
  } else {
    return props.direction
  }
}
</script>
